import { Injectable } from '@angular/core';
import * as Globals from '../../globals';
import * as CryptoJS from 'crypto-js';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { UserService } from "../user/user.service";
//import { Init } from "../../classes/init/init";

@Injectable({
    providedIn: 'root'
})
export class HelperService {



    constructor(
        private userService: UserService,
        protected localStorage: LocalStorage
    ) { }

    init() {
        return new Promise(resolve=>{
            this.localStorage.getItem("payload").subscribe( (storage : string) =>{
                this.userService.init(storage).subscribe((res) => {
                    if(res.success){
                        this.localStorage.setItem("user", res.user).subscribe(() => {
                            var user = res;
                            user.payload = storage;
                            resolve(user);
                        })
                    }else{
                        resolve(false)
                    }
                }, (error)=>{
                    resolve(false)
                })
            })
        })
    }

    public base64url(source) {
        // Encode in classical base64
        var encodedSource = CryptoJS.enc.Base64.stringify(source);

        // Remove padding equal characters
        encodedSource = encodedSource.replace(/=+$/, '');

        // Replace characters according to base64url specifications
        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');

        return encodedSource;
    }

    public preparePayload(data, domain, callback) {
        var header = {
            "typ": "JWT",
            "alg": "HS256"
        };

        var new_header = this.base64url(CryptoJS.enc.Utf8.parse(JSON.stringify(header)))
        data = this.base64url(CryptoJS.enc.Utf8.parse(data))

        var secret = Md5.hashStr(Globals.code + "8" + domain);
        var payload = CryptoJS.HmacSHA256(new_header + "." + data, secret);
        var signature = this.base64url(payload)

        var new_payload = new_header + "." + data + "." + signature

        if (callback) callback(new_payload)
    }
}
